import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode } from "vue";
const _hoisted_1 = { class: "row" };
const _hoisted_2 = { class: "col-12 text-subtitle2" };
const _hoisted_3 = { class: "row" };
const _hoisted_4 = {
    class: "self-center",
    style: { "min-width": "70px" }
};
const _hoisted_5 = { key: 0 };
const _hoisted_6 = {
    key: 0,
    class: "q-pl-xs self-center"
};
const _hoisted_7 = {
    key: 0,
    class: "col-12"
};
const _hoisted_8 = { class: "text-positive text-weight-bold text-body2 q-pr-sm" };
const _hoisted_9 = { class: "custom-text-b11" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_q_badge = _resolveComponent("q-badge");
    const _component_q_btn = _resolveComponent("q-btn");
    const _component_q_item_section = _resolveComponent("q-item-section");
    const _component_q_chip = _resolveComponent("q-chip");
    const _component_q_item = _resolveComponent("q-item");
    const _component_q_separator = _resolveComponent("q-separator");
    return (_openBlock(), _createElementBlock("div", null, [
        _createVNode(_component_q_item, {
            clickable: "",
            onClick: _ctx.clickEmit,
            id: `${_ctx.combineStringWithDelimiter(_ctx.title)}-option`
        }, {
            default: _withCtx(() => [
                (!_ctx.iconRight)
                    ? (_openBlock(), _createBlock(_component_q_item_section, {
                        key: 0,
                        avatar: ""
                    }, {
                        default: _withCtx(() => [
                            _createVNode(_component_q_btn, {
                                round: "",
                                flat: "",
                                dense: "",
                                unelevated: "",
                                name: _ctx.title,
                                icon: _ctx.icon,
                                size: _ctx.iconSize
                            }, {
                                default: _withCtx(() => [
                                    (_ctx.badgeCount > 0)
                                        ? (_openBlock(), _createBlock(_component_q_badge, {
                                            key: 0,
                                            color: "red",
                                            floating: ""
                                        }, {
                                            default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(_ctx.badgeCount), 1)
                                            ]),
                                            _: 1
                                        }))
                                        : _createCommentVNode("", true)
                                ]),
                                _: 1
                            }, 8, ["name", "icon", "size"])
                        ]),
                        _: 1
                    }))
                    : _createCommentVNode("", true),
                _createVNode(_component_q_item_section, null, {
                    default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_1, [
                            _createElementVNode("div", _hoisted_2, [
                                _createElementVNode("div", _hoisted_3, [
                                    _createElementVNode("div", _hoisted_4, [
                                        _createTextVNode(_toDisplayString(_ctx.title) + " ", 1),
                                        (_ctx.additionalData &&
                                            _ctx.additionalData.value &&
                                            _ctx.additionalData.position === 'side')
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_5, " : "))
                                            : _createCommentVNode("", true)
                                    ]),
                                    (_ctx.additionalData &&
                                        _ctx.additionalData.value &&
                                        _ctx.additionalData.position === 'side')
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                                            _createVNode(_component_q_chip, {
                                                square: "",
                                                dense: "",
                                                "text-color": "white",
                                                color: _ctx.additionalData.sidePosColor
                                            }, {
                                                default: _withCtx(() => [
                                                    _createTextVNode(_toDisplayString(_ctx.additionalData.value), 1)
                                                ]),
                                                _: 1
                                            }, 8, ["color"])
                                        ]))
                                        : _createCommentVNode("", true)
                                ])
                            ]),
                            (_ctx.additionalData &&
                                _ctx.additionalData.value &&
                                _ctx.additionalData.position !== 'side')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                                    _createElementVNode("span", null, [
                                        _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.additionalData.value), 1),
                                        _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.additionalData.title), 1)
                                    ])
                                ]))
                                : _createCommentVNode("", true)
                        ])
                    ]),
                    _: 1
                }),
                (_ctx.iconRight)
                    ? (_openBlock(), _createBlock(_component_q_item_section, {
                        key: 1,
                        avatar: ""
                    }, {
                        default: _withCtx(() => [
                            _createVNode(_component_q_btn, {
                                round: "",
                                flat: "",
                                dense: "",
                                unelevated: "",
                                name: _ctx.title,
                                icon: _ctx.icon,
                                size: _ctx.iconSize
                            }, {
                                default: _withCtx(() => [
                                    (_ctx.badgeCount > 0)
                                        ? (_openBlock(), _createBlock(_component_q_badge, {
                                            key: 0,
                                            color: "red",
                                            floating: ""
                                        }, {
                                            default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(_ctx.badgeCount), 1)
                                            ]),
                                            _: 1
                                        }))
                                        : _createCommentVNode("", true)
                                ]),
                                _: 1
                            }, 8, ["name", "icon", "size"])
                        ]),
                        _: 1
                    }))
                    : _createCommentVNode("", true)
            ]),
            _: 1
        }, 8, ["onClick", "id"]),
        (_ctx.showSeparator)
            ? (_openBlock(), _createBlock(_component_q_separator, { key: 0 }))
            : _createCommentVNode("", true)
    ]));
}
